module.exports = __webpack_public_path__ + "img/kakeibo-budget-planner_B09K1Z2QLJ.d8a5bed4.jpg";